import Vue from 'vue';
import Vuex from 'vuex';
// import dispatchActionForAllModules from '@utils/dispatch-action-for-all-modules'

import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import state from './state'
import { mergeDeep } from '@config/utils';

export function createStore (config) {
    Vue.use(Vuex);

    state.data.global.settings = mergeDeep(state.data.global.settings, config?.settings || {});
    state.data.global.definitions = mergeDeep(state.data.global.definitions, config?.definitions || {});

    // let modules = modulesState;
    const store = new Vuex.Store({
        state,
        mutations,
        actions,
        getters,
        // modules,
        // Enable strict mode in development to get a warning
        // when mutating state outside of a mutation.
        // https://vuex.vuejs.org/guide/strict.html
        // strict: process.env.NODE_ENV !== 'production',
    });

    return store;
};
